/**
 * This file contains common constants that will be used across app
 */
export const AppConstants = {
    REMITTANCE_ID_REGEX: {
        INR: "^[a-zA-Z0-9]*$",
        AED: "^[a-zA-Z0-9]+(-[a-zA-Z0-9]+)+$"
    },
    COIN_DEPOSIT_CODE_REGEX:"^[a-zA-Z0-9]+(-[a-zA-Z0-9]+)+$",
    ISSUE_LINK_REGEX: "^((http(s)?):\\/\\/)(tt|t\\.corp|issues|sim)\\.amazon.com[a-zA-Z0-9-\\/]*",
    LIABILITY_HISTORY_START_TIME: 0
}

export const APIGateway = {
    PROCESS_NAME: "cod"
}

export const APIEndpoint = {
    STATION_SUMMARY: "/getStationLiabilitySummary",
    GET_DRIVERS: "/getDrivers",
    DRIVER_RECONCILIATION: "/getDriverReconciliation",
    CREATE_DEPOSIT: "/createRemittance",
    UPDATE_REMITTANCE: "/updateRemittanceCode",
    GET_REMITTANCE: "/getRemittance",
    SUBMIT_REMITTANCE: "/submitRemittance",
    SUBMIT_COIN_REMITTANCE: "/depositAdhocRemittance",
    GET_REMITTANCE_DETAILS_FOR_EXCEL: "/getRemittanceDetailsForExcel",
    RUNNING_BALANCE_DETAILS: "/getRunningBalanceDetails",
    DRIVER_SHIPMENT_LIST_DETAILS: "/getDriverShipmentListDetails",
    ADD_STATION_VARIANCE_FOR_REMITTANCE: "/addStationVarianceForRemittance",
    VERIFY_REMITTANCE: "/verifyRemittance",
    SUBMIT_REMITTANCE_V2: "/submitRemittanceV2",
    RESET_REMITTANCE: "/resetRemittance"
};

export const CurrencySymbol = {
    INR: "₹",
    AED: "د.إ"
}

export const TIMEOUT_STRING = "timeout"

export const StringConstants = {
    SUCCESS: "SUCCESS",
    SEPARATOR: "@",
    YYYY_MM_DD: "YYYY-MM-DD",
    DAYS: "days"
}

export const metricType = {
    COUNT: "count"
};

export const Metric = {
    AppConfigFailure: "AppConfigFailure",
    CreateRemittance: "CreateRemittance",
    SubmitRemittance_Failure: "SubmitRemittance_Failure",
    SubmitRemittance: "SubmitRemittance",
    GetStationEODSummary_Failure: "GetStationEODSummary_Failure",
    GetStationEODSummary: "GetStationEODSummary",
    GetDriverReconciliation_Failure: "GetDriverReconciliation_Failure",
    GetDriverReconciliation: "GetDriverReconciliation",
    GetDrivers_Failure: "GetDrivers_Failure",
    GetDrivers: "GetDrivers",
    GetDriverShipmentListDetails_Failure: "GetDriverShipmentListDetails_Failure",
    GetDriverShipmentListDetails: "GetDriverShipmentListDetails",
    GetRunningBalanceDetails: "GetRunningBalanceDetails",
    GetRunningBalanceDetails_Failure: "GetRunningBalanceDetails_Failure",
    GetRemittanceDetailsForExcel_Failure: "GetRemittanceDetailsForExcel_Failure",
    GetRemittanceDetailsForExcel: "GetRemittanceDetailsForExcel",
    GetRemittance_Failure: "GetRemittance_Failure",
    GetRemittance: "GetRemittance",
    GetStationLiabilitySummary_Failure: "GetStationLiabilitySummary",
    GetStationLiabilitySummary: "GetStationLiabilitySummary"

}

export const PROCESS_NAME = "SCC_COD";


// WEBPACK FOOTER //
// ./src/component/common/constants.js